import './web-animations-js'
import './seamless-scroll-polyfill'
import './HiyaJSBridge'
import 'core-js/stable'
import 'antd-mobile/es/global'
import {loadableReady} from '@loadable/component'
import * as Sentry from '@sentry/react'
import {BrowserTracing} from '@sentry/tracing'
import {createBrowserHistory} from 'history'
import App from 'hiya-common/src/App/index'
import {http} from 'hiya-common/src/utils/axios'
import React from 'react'
import {hydrate} from 'react-dom'
import {Provider} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import {matchPath, Router} from 'react-router-dom'
import {StoreType} from '../stores/index'
import {isZY} from '../utils'
import PendingNavDataLoader from './PendingNavDataLoader'
// import '../utils/inobounce'
// import 'inobounce'
import './index.scss'

const history = createBrowserHistory()
export {history}

const postMessageCallbacks = []
// 检查是否已存在相同的回调
const isCallbackExists = (method, callbackFunc) => {
  return postMessageCallbacks.some(
    (cb) => cb.method === method && `${cb.callbackFunc}` === `${callbackFunc}` // 函数转字符串后进行比较
  )
}

export const init = ({createStore, getRoutes, projectConfig}) => {
  const AppWithSentry = Sentry.withProfiler(App, {
    name: projectConfig.project,
  })

  const store: StoreType = createStore(window.APP_INITIAL_STATE)
  window.store = store
  window.APP_INITIAL_STATE = null
  http.setPublicFunction({
    log: console,
  })
  const routes = getRoutes(store)
  if (ENV !== 'development') {
    Sentry.init({
      dsn: XC_SENTRY_CLIENT, // webpack打包时暴露的全局变量，在src/.xcsentryrc文件中定义
      integrations: [
        new BrowserTracing({
          // https://docs.sentry.io/platforms/javascript/guides/react/performance/instrumentation/automatic-instrumentation/
          tracingOrigins: projectConfig.tracingOrigins, // 不包含stat.izuiyou.com，避免给埋点请求添加sentry请求头导致埋点请求失败
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(
            history,
            routes,
            matchPath
          ),
        }),
      ],
      ignoreErrors: [
        'Non-Error promise rejection captured with keys: message',
        "Can't find variable: HiyaJSBridge",
        'Non-Error promise rejection captured with keys: message, name, stack',
        'ResizeObserver loop limit exceeded',
        'Bad control character in string literal in JSON at position 248',
        'Bad control character in string literal in JSON at position',
        'HiyaJSBridge is not defined',
        "Invalid character '\u0301'",
        'Non-Error promise rejection captured with value:',
      ],
      tracesSampleRate: 0.05, // 测试环境调试可适当加大此值，线上建议根据项目日PV设置为0.05 ~ 0.1
      sampleRate: 0.05,
    })
    try {
      const data = store.getState().env
      Sentry.setUser({
        ...data,
        id: String(data.deviceinfo.h_m),
        ip_address: '{{auto}}',
      })
    } catch (error) {
      //
    }
  }

  const application = (
    <Provider store={store}>
      <Router history={history}>
        <PendingNavDataLoader store={store} routes={routes}>
          {() => <AppWithSentry>{renderRoutes(routes)}</AppWithSentry>}
        </PendingNavDataLoader>
      </Router>
    </Provider>
  )

  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('isHigoGame') === 'true') {
    window.addEventListener('message', (event: MessageEvent) => {
      const {data} = event
      console.log('游戏h5收到postMessage消息', data)
      postMessageCallbacks.forEach((callback) => {
        if (data && data.method === callback.method) {
          console.log('游戏h5执行回调函数', data.method)
          callback.callbackFunc(data.param)
        }
      })
    })
  }

  Promise.all([
    new Promise((res) => {
      // ios 4.16.0 未给userAgent 写入 inapp
      if (isZY() || store.getState().env.deviceinfo?.h_av === '4.16.0') {
        if (window.HiyaJSBridge) {
          res(null)
        } else {
          document.addEventListener('HiyaJSBridgeReady', () => {
            res(null)
          })
        }
      } else {
        const nop = () => {
          // 防止端外报错
        }
        const h5CallHandler = (method, data, callbackFunc) => {
          if (method === 'getDeviceInfo' && callbackFunc) {
            // 添加前检查是否已存在
            if (!isCallbackExists(method, callbackFunc)) {
              postMessageCallbacks.push({method, callbackFunc})
            }
          }
          const message = {
            method,
            param: data || '',
          }
          window.parent.postMessage(message, '*')
        }
        const h5RegisterHandler = (method, callbackFunc) => {
          if (method === 'webMessage') {
            // 添加前检查是否已存在
            if (!isCallbackExists(method, callbackFunc)) {
              postMessageCallbacks.push({method, callbackFunc})
            }
          }
        }
        window.HiyaJSBridge = {
          registerHandler: h5RegisterHandler,
          callHandler: h5CallHandler,
          unregisterHandler: nop,
        }
        res(null)
      }
    }),
    new Promise((res) => {
      loadableReady(() => {
        res(null)
      })
    }),
  ]).then(() => {
    const root = document.getElementById('app')
    hydrate(application, root)
  })
}
